export const FETCH_ROLES_REQUEST = "FETCH_ROLES_REQUEST";
export const FETCH_ROLES_SUCCESS = "FETCH_ROLES_SUCCESS";
export const FETCH_ROLES_FAILURE = "FETCH_ROLES_FAILURE";

export const FETCH_ONE_ROLE_SUCCESS = "FETCH_ONE_ROLE_SUCCESS";
export const FETCH_ALL_ROLES_SUCCESS = "FETCH_ALL_ROLES_SUCCESS";

export const FETCH_ALL_PERMISSIONS_FAILURE = "FETCH_ALL_PERMISSIONS_FAILURE";
export const FETCH_ALL_PERMISSIONS_SUCCESS = "FETCH_ALL_PERMISSIONS_SUCCESS";

export const UPDATE_ROLES = "UPDATE_ROLES";
export const DELETE_ROLES = "DELETE_ROLES";

export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";
